/* NOTE: un-comment below line and it will show how unnecessary re-render of component in console log*/

//import './wdyr';
import React from 'react';
import { Route, HashRouter } from 'react-router-dom';
import MttDashboard from './containers/mttDashboardContainer';
import Loader from './components/loader';
import { connect } from 'react-redux';
import { ConfigInitialStateTypes } from './types/reducerTypes';
import { Dispatch } from 'redux';
import { routes } from './constants/utilConstants';

interface Props {
  config: ConfigInitialStateTypes;
}

const App: React.FC<Props> = (props) => {
  const { config } = props;
  return (
    <div>
      <Loader show={config.isLoading} />
      <HashRouter>
        <Route path={routes.MTT_DASHBOARD} exact component={MttDashboard} />
      </HashRouter>
    </div>
  );
};
const mapStateToProps = (props: Props): Props => {
  return {
    config: props.config,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): object => {
  return { dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
